import { defineMessages } from 'react-intl'

export default defineMessages({
  details: {
    id: 'containers.CustomerOrderUpsertPage.containers.UpdatePage.details',
    defaultMessage: 'Details',
  },
})
